import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link, Table } from 'tdesign-react';
import { useMemoizedFn } from 'ahooks';
import { renderDateTime } from '@/utils/common';
import { getPageConfig } from '@/hooks/useTable';
import { getSchemaList } from '@/services/topicService';
import JSONModal from '@/components/JSONModal';

export default function SchemaPanel({ commonProps }) {
  const [data, setData] = useState([]);
  const [json, setJson] = useState({});
  const [visible, setVisible] = useState(false);

  const loadData = useMemoizedFn(async () => {
    const { data } = await getSchemaList(commonProps);
    setData(data);
  });

  useEffect(() => {
    loadData();
  }, [loadData]);

  const columns = [
    {
      title: '类型',
      colKey: 'type',
      width: 180,
    },
    {
      title: '版本',
      colKey: 'version',
      width: 180,
    },
    {
      title: '创建时间',
      colKey: 'lastTimestamp',
      cell: renderDateTime,
      width: 200,
    },
    {
      title: '结构定义',
      colKey: 'schemaDefinition',
      cell: ({ row }) =>
        row.schemaDefinition?.length > 60 ? (
          <>
            <span>{row.schemaDefinition.substring(0, 60)}...</span>
            <Link theme='primary' onClick={() => showJSON(row.schemaDefinition)}>
              展开
            </Link>
          </>
        ) : (
          row.schemaDefinition
        ),
    },
  ];

  const showJSON = (jsonStr) => {
    setJson(JSON.parse(jsonStr));
    setVisible(true);
  };

  return (
    <>
      <Title>SCHEMA</Title>
      <Table
        data={data}
        columns={columns}
        maxHeight={1000}
        style={{ marginTop: 16 }}
        pagination={{
          ...getPageConfig(data),
          defaultCurrent: 1,
        }}
      />
      <JSONModal
        title='Schema Definition'
        json={json}
        visible={visible}
        handleClose={() => setVisible(false)}
      />
    </>
  );
}

const Title = styled.div`
  color: var(--td-font-gray-1);
  font-size: 14px;
  font-weight: bold;
  margin: 16px 0 20px;
  padding-left: 4px;
`;
